import {EventEmitter} from "@angular/core";
import {Subject} from "rxjs";

/**
 * Event triggered when a value for a filter changes
 */
export class FilterValueChangedEvent {
    filterName: string;
    value: any;

    constructor(filterName: string, value: any) {
        this.filterName = filterName;
        this.value = value;
    }
}


export abstract class AbstractSearchModel {
    /**
     * Define the filter for the search
     * @type {{}}
     */
    abstract filter: any;

    /**
     * emits events when a specific field value changes
     * @type {EventEmitter<FilterValueChangedEvent>}
     */
    filterFieldChange: EventEmitter<FilterValueChangedEvent> = new EventEmitter();

    /**
     * emits an event when the filter has changed
     * @type {EventEmitter}
     */
    filterChange: EventEmitter<any> = new EventEmitter();

    clearFilterOptions$: Subject<void> = new Subject<void>();

    /**
     * Set a filter value triggering FilterValueChangedEvent and FilterChange
     * @param filterName
     * @param value
     */
    abstract setFilterValue(filterName: string, value: any): void

    /**
     * Set filter values using a object iterating through the properties and its values triggering FilterValueChangedEvent and FilterChange
     * @param filter
     */
    abstract setFilterValues(filter: any): void;

    abstract getFilterValue(filterName): any;

    abstract getResource(): string;

    abstract isEntityLocalisable(): boolean;
}
